import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';
import {BackgroundComponent} from '../background/background.component';
import {ColorComponent} from '../color/color.component';

@Component({
  selector: 'app-step-active',
  imports: [
    BackgroundComponent,
    ColorComponent
  ],
  templateUrl: './step-active.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './step-active.component.scss'
})
export class StepActiveComponent extends AbstractStyleComponent {
  @ViewChild('color') colorComponent!: ColorComponent;
  @ViewChild('background') backgroundComponent!: BackgroundComponent;

  getValue(): any {
    return {
      background: this.backgroundComponent.getValue(),
      color: this.colorComponent.getValue(),
    };
  }

  setValue(value: any): void {
    this.backgroundComponent.setValue(value['background']);
    this.colorComponent.setValue(value['color']);
  }
}
